module.exports = __webpack_public_path__ + "static/media/meena.273e7053.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/meena.jpg
// module id = 1289
// module chunks = 0